<form autocomplete="off" class="p-0" novalidate [formGroup]="photoSignDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-2">
            <div>
                <h4 class="main-content-label mb-2"><b>Photo & Signature</b></h4>
            </div>
            <div class="row g-3 align-items-stretch">
                <div class="col-sm-4 d-flex">
                    <div class="card h-100 w-100">
                        <div class="card-body p-2">
                            <label class="form-label">Upload Photo</label>
                            <div class="upload-container mt-2" style="min-height: 250px; overflow: hidden;">
                                <div class="size-indicator-frame" style="width: 200px; height: 230px; margin: 0 auto; border: 2px dashed #ccc; position: relative;">
                                    <div class="size-label" style="position: absolute; bottom: -25px; left: 50%; transform: translateX(-50%); font-size: 11px; color: #666;">
                                        
                                    </div>
                                    <div class="col-sm-12" formControlName="StuPhoto" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                                        <img *ngIf="!userImage" class="default-img" src="../../assets/images/user2.png"
                                            alt="Amanda Wilson" style="max-width: 100%; max-height: 100%; object-fit: contain;">
                                        <img *ngIf="userImage" class="img-preview" [src]="userImage" alt="patient photo"
                                            style="max-width: 100%; max-height: 100%; object-fit: contain;">
                                    </div>
                                </div>
                            </div>
                            <div class="text-center mt-2">
                                <input #fileUpload type="file" style="display: none;" (change)="onChange1($event)" accept=".jpg,.jpeg" />
                                <div class="d-flex justify-content-center mb-1">
                                    <button type="button" class="btn btn-light btn-sm shadow"
                                        matTooltip="Upload JPG/JPEG image. Max 50KB. Dimensions: 200x230 pixels."
                                        (click)="fileUpload.click()">
                                        <i class="ai-refresh-cw me-2"></i>Upload Photo
                                    </button>
                                </div>
                                <mat-error class="redCol d-block"
                                    *ngIf="photoSignDetailsForm.controls['StuPhoto'].touched && photoSignDetailsForm.controls['StuPhoto'].errors?.required">
                                    Photo is mandatory
                                </mat-error>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-sm-4 d-flex">
                    <div class="card h-100 w-100">
                        <div class="card-body p-2">
                            <label class="form-label">Upload Signature</label>
                            <div class="signature-container mt-2" style="min-height: 250px; overflow: hidden;">
                                <div class="size-indicator-frame" style="width: 140px; height: 60px; margin: 0 auto; border: 2px dashed #ccc; position: relative;">
                                    <div class="size-label" style="position: absolute; bottom: -25px; left: 50%; transform: translateX(-50%); font-size: 11px; color: #666;">
                                       
                                    </div>
                                    <div class="col-sm-12" formControlName="StuSignature" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                                        <img *ngIf="!signatureImage" class="default-sign" src="../../assets/images/sign.png"
                                            alt="Amanda Wilson" style="max-width: 100%; max-height: 100%; object-fit: contain;">
                                        <img *ngIf="signatureImage" class="img-preview" [src]="signatureImage" alt="patient photo"
                                            style="max-width: 100%; max-height: 100%; object-fit: contain;">
                                    </div>
                                </div>
                            </div>
                            <div class="text-center mt-2">
                                <input #fileUpload2 type="file" style="display: none;" (change)="onChangeSign($event)" accept=".jpg,.jpeg" />
                                <div class="d-flex justify-content-center mb-1">
                                    <button type="button" class="btn btn-light btn-sm shadow"
                                        matTooltip="Upload JPG/JPEG image. Max 20KB. Dimensions: 140x60 pixels."
                                        (click)="fileUpload2.click()">
                                        <i class="ai-refresh-cw me-2"></i>Upload Sign
                                    </button>
                                </div>
                                <mat-error class="redCol d-block"
                                    *ngIf="photoSignDetailsForm.controls['StuSignature'].touched && photoSignDetailsForm.controls['StuSignature'].errors?.required">
                                    Signature is mandatory
                                </mat-error>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 d-flex">
                    <div class="card h-100 w-100">
                        <div class="card-body p-2" style="min-height: 250px;">
                            <label class="form-label">Upload Requirements</label>
                            <div class="requirements-box mt-2">
                                <div class="fw-bold">Photo Requirements</div>
                                <div>• JPG/JPEG • Max 50KB</div>
                                <div>• 200 x 230 pixels</div>
                            </div>
                            <div class="requirements-box mt-1">
                                <div class="fw-bold">Signature Requirements</div>
                                <div>• JPG/JPEG • Max 20KB</div>
                                <div>• 140 x 60 pixels</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="button-container mt-3">
                <div class="row">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="updateButton" [disabled]="disabled || isSaving"
                            (click)="updateCheck()" class="btn btn-primary btn-sm fr sz">
                            <span style="display: contents; align-items: center;">
                                <img width="16" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                        <button type="button" *ngIf="submitButton"
                            class="btn btn-primary btn-sm fr sz" [disabled]="isSaving"
                            (click)="submitCheck()">
                            <span style="display: contents; align-items: center;">
                                <img width="16" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" (click)="back()" class="btn btn-light btn-sm fr">
                            <span style="display: contents; align-items: center;">
                                <img width="16" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>